//services

//reducers
import { selectImageUrl, selectTranslations } from 'state/reducers/translation.reducers';

//components
import { FormCard } from 'theme/elements/Forms';
import { FormHeader1, HeaderPage4 } from 'theme/elements/Headers';
//sections
//mui
import UploadFile from '@mui/icons-material/UploadFile';
import CheckCircleOutlineRounded from '@mui/icons-material/CheckCircleOutlineRounded';

import { Box, Button, Stack, Typography, useTheme } from '@mui/material';
//constants
import { balanceTransStepsPrefix } from 'constants/balance.constants';
import { useAppSelector } from 'hooks/redux.hooks';
import React, { useState } from 'react';
import { FormButton } from 'theme/elements/Buttons';
import ErrorBox from './ErrorBox';
import { acceptableFileFormats, maxFileSize } from 'constants/global.constants';
import { validateFileExtensions } from 'utils';

export default function FileUploadBox({ labelPrefix, handleTransferProofFile, isFileUploaded, imageKey }) {
	const t = useAppSelector(selectTranslations);
	const imageUrl = useAppSelector(selectImageUrl);
	const theme = useTheme();
	const [fileName, setFileName] = useState<string | null>(null);
	const [showErrorBox, setShowErrorBox] = useState(false);
	const [errorText, setErrorText] = useState<string | null>(null);

	const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
		setShowErrorBox(false);
		const file: File = event.target.files![0];
		if (file) {
			if (validateFileExtensions(file.type)) {
				if (file.size <= maxFileSize) {
					setFileName(file.name);
					handleTransferProofFile(file);
				} else {
					setFileName(null);
                    setErrorText(t(`servers.errors.codes.1302`));
					setShowErrorBox(true);
				}
			} else {
				setFileName(null);
                setErrorText(t(`errors.files.upload.file_type_not_supported.title`));
				setShowErrorBox(true);
			}
		}
	};

	return (
		<Box component="form">
			<Stack marginTop="32px">
				<FormCard>
					<Stack spacing={4}>
						<FormHeader1 title={t(labelPrefix + 'title')} text={t(labelPrefix + 'text')} />
						<Stack spacing={1}>
							<Stack direction="column" overflow="hidden">
								<Stack
									direction="row"
									alignItems="center"
									justifyContent="space-between"
									sx={{
										backgroundColor: theme.palette.root.brandSecondary_012,
										padding: '32px',
										borderRadius: '8px',
									}}
								>
									{!fileName ? (
										<HeaderPage4
											title={t(`${labelPrefix}reference_doc.no_file_selected.title`)}
											text={t(`${labelPrefix}reference_doc.no_file_selected.text`)}
										/>
									) : (
										<Typography sx={{ overflowWrap: 'break-word', maxWidth: '50%' }}>
											{fileName}
										</Typography>
									)}
									<FormButton>
										<Button
											variant="outlined"
											sx={{
												'&.MuiButton-outlined': {
													borderColor: theme.palette.root.basicDeepGreen,
												},
											}}
											component="label"
											startIcon={isFileUploaded ? <CheckCircleOutlineRounded /> : <UploadFile />}
										>
											{t(
												`${balanceTransStepsPrefix}.2.currency_approval.reference_doc.file_upload_button.text`
											)}
											<input
												type="file"
												onChange={handleFileUpload}
												hidden
												accept={acceptableFileFormats}
											/>
										</Button>
									</FormButton>
								</Stack>
							</Stack>
							{showErrorBox && (
								<ErrorBox
									icon={<img src={imageUrl(imageKey || '') || '/icons/file_error.svg'} />}
									text={errorText}
								/>
							)}
						</Stack>
					</Stack>
				</FormCard>
			</Stack>
		</Box>
	);
}
